import { accountPath } from '../accountRelatedModel';

export const CASES_SIDEBAR_LABEL = 'Campaign Operation Cases';
export const CASES_PATH_SUFFIX = '/campaign-cases';

export const OWNER_GROUP_ORDER = ['Avery Stone', 'Jordan Reed', 'Casey Lin', 'Riley Park'];

export const COMPOSER_TABS = [
  { value: 'post', label: 'Post', placeholder: 'Share an update...' },
  { value: 'quick', label: 'Quick Update', placeholder: 'Post a quick update...' },
  { value: 'customer', label: 'Email to Customer', placeholder: 'Email to customer...' },
  { value: 'vendor', label: 'Email to Vendor', placeholder: 'Email to vendor...' },
] as const;

export function casesListPath(accountId: string, offerId?: string): string {
  return accountPath(accountId, offerId, CASES_PATH_SUFFIX);
}

export function casePath(accountId: string, offerId: string | undefined, caseNumber: string): string {
  return accountPath(accountId, offerId, `${CASES_PATH_SUFFIX}/${caseNumber}`);
}
